import Modules from './blog/modules/'
import initModules from './modules/ModulesInitializer'
import { SearchBar, Header, MainNav, CookieWidget, GtmEvents } from './core'
import { FeatureDetection } from './utils/'

const initSite = () => {
  CookieWidget.init()
  initModules(Modules)

  SearchBar.init()
  Header.init()
  MainNav.init()

  FeatureDetection.getCssClasses().forEach(classname => document.body.classList.add(classname.cssClass))
  // must run last in order
  GtmEvents.init()
}

// Initialise all modules found on a given page
// Alternative to peppering the site with difficult to manage script blocks
document.addEventListener('DOMContentLoaded', initSite)



// WEBPACK FOOTER //
// ./js/Blog.js